import { useRef, useEffect } from 'react';
import { changeColorOpacity } from '@shopify/polaris-viz-core';
import styles from './Shimmer.scss.js';
import { jsx } from 'react/jsx-runtime';

function Shimmer({
  backgroundColor,
  width,
  height
}) {
  const semiTransparentBackground = changeColorOpacity(backgroundColor, 0);
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current === null) return;
    ref.current.style.setProperty('--shimmerWidth', `${width}px`);
    ref.current.style.setProperty('--shimmerHeight', `${height}px`);
  }, [width, height]);
  const [min, max] = [width, height];
  const angle = Math.asin(max / min) / (Math.PI / 180);
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: styles.Shimmer,
    style: {
      backgroundImage: `linear-gradient(-${angle}deg,
            ${semiTransparentBackground} 10%,
            ${semiTransparentBackground} 35%,
            ${backgroundColor} 50%,
            ${semiTransparentBackground} 65%,
            ${semiTransparentBackground} 100%)`
    }
  });
}

export { Shimmer };
